import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { store } from "../../../../shared/store";
import { getFormattedDate } from "../../../../shared/helpers/date-helper";
import {
  getScoresPerPage,
  hidden,
  normalizeScoreBarHeight,
  stringToFloat,
} from "../../../../shared/helpers/ui-helper";
import { getDifferential } from "../../../../shared/helpers/scores-helper";

class GraphView extends Component {
  state = {
    offset: 0,
    golferActive:
      store.getState().profileReducer.golferProfileFetchReducer.golferActive,
    useScaling:
      store.getState().profileReducer.golferProfileFetchReducer.golferProfile
        ?.use_scaling,
    trialGolfer:
      store.getState().profileReducer.golferProfileFetchReducer.trialGolfer,
  };

  recentScoresSliderRef;

  hasPrev = () =>
    this.props.scores.length > this.state.offset + this.state.limit;

  hasNext = () => this.state.offset !== 0;

  componentDidMount = () =>
    this.setState({
      limit: getScoresPerPage(
        this.recentScoresSliderRef,
        this.props.defaultScoresPerPage
      ),
    });

  fetchNext = (forward) => {
    const limit = getScoresPerPage(
      this.recentScoresSliderRef,
      this.props.defaultScoresPerPage
    );
    const { offset } = this.state;
    let newOffset = forward ? offset - limit : offset + limit;
    newOffset = newOffset < 0 ? 0 : newOffset;
    this.setState({ offset: newOffset, limit: limit });
  };

  renderPlayedHoles(score) {
    if (score.number_of_played_holes > 9 && score.number_of_played_holes < 18) {
      return (
        <span className="subscript">{`(${score.number_of_played_holes})`}</span>
      );
    }
  }

  getScoreType = (score) => score.score_type_display_short === "N" && "N";

  getScoresPage = () => {
    const scoresPerPage = getScoresPerPage(
      this.recentScoresSliderRef,
      this.props.defaultScoresPerPage
    );
    const scores = this.props.scores.slice(
      this.state.offset,
      this.state.offset + scoresPerPage
    );
    return scores.reverse();
  };

  render() {
    return (
      <div
        className="section__body panel recent-scores__slider"
        ref={(ref) => (this.recentScoresSliderRef = ref)}
      >
        <div className="custom-chart">
          <div className="cusutom-chart__container">
            <div className="custom-chart__timeline">
              {this.getScoresPage().map((score, key) =>
                this.renderScore(score, key)
              )}
              <div className="custom-chart_h" />
            </div>
          </div>
          {this.renderControls()}
        </div>
      </div>
    );
  }

  render_tooltip = (score) => (
    <Fragment>
      <p>{score.facility_name}</p>
      {score.facility_name !== score.course_name && <p>{score.course_name}</p>}
      <div className={"score_info" + (this.state.trialGolfer ? " trial" : "")}>
        <div>
          SCORE
          <br />
          <span>
            {score.adjusted_gross_score}
            {this.state.useScaling && this.renderPlayedHoles(score)}
            {this.state.useScaling && this.getScoreType(score)}
          </span>
        </div>
        {!this.state.trialGolfer && (
          <div>
            C.R./SLOPE
            <br />
            <span>
              {stringToFloat(score.course_rating, 1)}/{score.slope_rating}
            </span>
          </div>
        )}
        {!this.state.trialGolfer && (
          <div>
            DIFF
            <br />
            <span>{getDifferential(score, this.state.useScaling)}</span>
          </div>
        )}
      </div>
    </Fragment>
  );

  renderControls = () => (
    <Fragment>
      <button
        className={`custom-chart__control prev ${hidden(!this.hasPrev())}`}
        onClick={() => this.fetchNext(false)}
      >
        <i className="material-icons-outlined">chevron_left</i>
      </button>
      <button
        className={`custom-chart__control next ${hidden(!this.hasNext())}`}
        onClick={() => this.fetchNext(true)}
      >
        <i className="material-icons-outlined">chevron_right</i>
      </button>
    </Fragment>
  );

  renderScore = (score, key) => (
    <div
      key={key}
      className={
        "custom-chart__bar" + (this.state.golferActive ? "" : " no-hover")
      }
      style={{
        height: `${normalizeScoreBarHeight(score.adjusted_gross_score)}%`,
      }}
    >
      <span className="custom-chart__bar__value">
        {score.adjusted_gross_score}
      </span>
      <span className="custom-chart__bar__date">
        {getFormattedDate(score.played_at, "YYYY-MM-DD", "MM/DD/YY")}
      </span>
      {this.state.golferActive && (
        <div
          className={"hover_tooltip" + (this.state.trialGolfer ? " trial" : "")}
        >
          {this.render_tooltip(score)}
        </div>
      )}
    </div>
  );

  reverseScores = (scores) => scores.reverse();
}

GraphView.propTypes = {
  defaultScoresPerPage: PropTypes.number.isRequired,
  scores: PropTypes.array.isRequired,
};

export default GraphView;
